/**
 * Per-site official school calendar PDF paths (mirror parentPacketHandbook.js).
 * Prefer token-scoped API PDF when the site has a calendar form slot.
 * 14th-ave: official 63rd-St/Brooklyn calendar at /packet/14th-ave/…
 */

export const CALENDAR_ICS_BUTTON_LABEL = 'Add school dates to your calendar';

export const CALENDAR_FORM_BY_SITE = {
  rockland: 'form_05',
  '55th-street': 'bs_16',
  woodmere: 'wm_16',
  '14th-ave': 'fa_02',
};

const STATIC_CALENDAR_BY_SITE = {
  rockland: '/packet/rockland/school-calendar-2026-2027.pdf',
  '55th-street': '/packet/55th-street/school-calendar-2026-2027.pdf',
  '14th-ave': '/packet/14th-ave/school-calendar-2026-2027.pdf',
  woodmere: '/packet/woodmere/woodmere-school-calendar-2026-2027.pdf',
};

export function calendarFormIdForSite(siteSlug) {
  return CALENDAR_FORM_BY_SITE[siteSlug] || null;
}

export function allCalendarFormIds() {
  return Object.values(CALENDAR_FORM_BY_SITE);
}

/** Resolve href for View school calendar (PDF). */
export function parentCalendarPdfHref({ siteSlug, token, apiBaseUrl }) {
  const calendarFormId = calendarFormIdForSite(siteSlug);
  if (calendarFormId && token && apiBaseUrl) {
    return `${apiBaseUrl}/packet/${encodeURIComponent(token)}/${encodeURIComponent(calendarFormId)}/pdf/`;
  }
  return STATIC_CALENDAR_BY_SITE[siteSlug] || null;
}

/** DB-driven school-year calendar (.ics) for the student's session. */
export function parentCalendarIcsHref({ token, apiBaseUrl }) {
  if (!token || !apiBaseUrl) return null;
  return `${apiBaseUrl}/packet/${encodeURIComponent(token)}/calendar.ics`;
}

export function isCalendarPacketForm(formId, siteSlug) {
  return formId === calendarFormIdForSite(siteSlug);
}

/** Woodmere summer program static .ics (wm_16 copy references this). */
export const WOODMERE_SUMMER_ICS_PATH = '/packet/woodmere/woodmere-summer-2026.ics';

export function openParentCalendarPdf(href) {
  if (!href) return;
  const anchor = document.createElement('a');
  anchor.href = href;
  anchor.target = '_blank';
  anchor.rel = 'noopener noreferrer';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}
